/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import AddClub from './component/add'

class ClubAdd extends React.Component {
  static defaultProps = {
    clubInfo: {},
  }

  render() {
    const { clubInfo } = this.props
    return (
      <div style={{ position: 'relative', height: '80vh' }}>
        <AddClub clubInfo={clubInfo} fetchAddClub={this.props.fetchAddClub} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    clubInfo: state.getClubAdd.clubInfo,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubAdd))



// WEBPACK FOOTER //
// ./src/containers/ClubAdd/index.js